import { useEffect } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useRouter, usePathname } from 'expo-router';
import { Paprika, PaprikaSpacing, PaprikaTypography } from '../src/styles/theme';
import { useTranslation } from 'react-i18next';

export default function NotFound() {
  const { t } = useTranslation();
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    // Redirect old-format recipe URLs immediately to the correct route
    const recipeMatch = pathname.match(/^\/recipes\/((?:saved|imported)-[^/?]+)/);
    if (recipeMatch) {
      router.replace(`/(app)/recipe-detail/${recipeMatch[1]}`);
      return;
    }

    const timer = setTimeout(() => {
      router.replace('/(app)/recipes');
    }, 1500);
    return () => clearTimeout(timer);
  }, [router, pathname]);

  return (
    <View style={styles.container}>
      <Text style={styles.text}>{t('common.pageNotFound')}</Text>
      <Text style={styles.subtext}>{t('common.redirecting')}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Paprika.background,
    padding: PaprikaSpacing.lg,
  },
  text: {
    ...PaprikaTypography.headingMedium,
    color: Paprika.textPrimary,
    textAlign: 'center',
  },
  subtext: {
    ...PaprikaTypography.bodyMedium,
    color: Paprika.textSecondary,
    marginTop: PaprikaSpacing.sm,
    textAlign: 'center',
  },
});
